import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createAppTheme, darkPalette, lightPalette } from "@/theme";

type ThemeMode = "light" | "dark";

interface ThemeContextType {
	mode: ThemeMode;
	toggleTheme: () => void;
	setTheme: (mode: ThemeMode) => void;
	theme: ReturnType<typeof createAppTheme>;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [mode, setMode] = useState<ThemeMode>(() => {
		return "light";
		// TODO: Uncomment this when we have dark mode in all the pages and components

		// const stored = localStorage.getItem("themeMode") as ThemeMode | null;

		// if (stored) {
		// 	return stored;
		// }

		// const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
		// return prefersDark ? "dark": "light";
	});

	const theme = useMemo(() => {
		return createAppTheme(mode === "light" ? lightPalette : darkPalette);
	}, [mode]);

	useEffect(() => {
		localStorage.setItem("themeMode", mode);
	}, [mode]);

	const toggleTheme = () => {
		setMode((prev) => (prev === "light" ? "dark" : "light"));
	};

	const setTheme = (newMode: ThemeMode) => {
		setMode(newMode);
	};

	return <ThemeContext.Provider value={{ mode, toggleTheme, setTheme, theme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
	const context = useContext(ThemeContext);
	if (!context) {
		throw new Error("useTheme must be used within a ThemeProvider");
	}
	return context;
};
